"use client";

import { useEffect, useRef } from "react";
import styles from "./selector-component.module.css";
import { KeyboardArrowDown } from "@mui/icons-material";

export default function SelectorComponent({
  children,
  title,
  description,
  hasSelection,
  isOpen,
  hasError,
  setIsOpen,
  leftIcon,
}: {
  children: React.ReactNode;
  title: string;
  description: string;
  hasSelection: boolean;
  isOpen: boolean;
  hasError: boolean;
  setIsOpen: () => void;
  leftIcon?: React.ReactNode;
}) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        if (isOpen) setIsOpen();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  return (
    <div
      className={`${styles.contentWrapper} ${isOpen ? styles.isActive : ""}`}
      ref={wrapperRef}
    >
      <button
        className={styles.triggerButton}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-invalid={hasError}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen();
        }}
      >
        <div className={styles.leftSideWrapper}>
          {leftIcon && <span className={styles.leftIcon}>{leftIcon}</span>}

          <div className={styles.textWrapper}>
            <span
              className={`${styles.title} ${hasError ? styles.hasError : ""}`}
            >
              {title}
            </span>
            <span
              className={`${styles.description} ${
                hasSelection ? styles.hasSelection : ""
              } ${hasError ? styles.hasError : ""}`}
            >
              {description}
            </span>
          </div>
        </div>

        <KeyboardArrowDown
          aria-hidden="true"
          className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""} ${
            hasError ? styles.hasError : ""
          }`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className={styles.dropdownMenu}>
          <ul className={styles.selectionList} role="listbox">
            {children}
          </ul>
        </div>
      )}
    </div>
  );
}
